import { Typography } from 'antd';
import moment, { Moment } from 'moment';
import DatePicker from '../../../../../lib/MomentDatePicker';
import { DateFormat } from '../../../../../utils/StaticVariable';
import styles from '../Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface DateFieldProps {
  label: string;
  testId: string;
  value: Moment | null;
  onChange: (date: Moment | null) => void;
  disabledDate: (date: Moment) => boolean;
  disabled?: boolean;
}

export const DateField = ({
  label,
  testId,
  value,
  onChange,
  disabledDate,
  disabled = false,
}: DateFieldProps) => (
  <div className={`${styles.formItem} ${styles.dateItem}`} data-testid={testId}>
    <Text>{label}</Text>
    <DatePicker
      value={value ? moment(value) : null}
      disabledDate={disabledDate}
      onChange={onChange}
      format={DateFormat}
      disabled={disabled}
    />
  </div>
);
